/**
 * Use this file to store text re-used quite often across all domains.
 */

export const genericErrorMessage = `We're sorry, something didn't work quite right.`;

export const noSearchResults = 'No results match this search.';
export const noDataPresent = 'No data present for this account';
export const noDataAvailable = "We're sorry, data is unavailable";
